import React, { useEffect } from 'react';
import dog from '../../assets/images/dog.png';
import './Dog.scss';
import { useDog } from '../../context/DogContext.jsx';

const Dog = () => {
    const { isDogVisible, showDog, hideDog } = useDog();

    useEffect(() => {
        if (window.innerWidth <= 768) {
            const timer1 = setTimeout(() => {
                showDog();

                const timer2 = setTimeout(() => {
                    hideDog();
                }, 7800);

                return () => clearTimeout(timer2);
            }, 15000);
          
            return () => clearTimeout(timer1);
        }
    }, []);

    return (
        <img 
            src={dog} 
            alt="Dog" 
            className={`dog-img ${isDogVisible ? 'visible' : ''}`}
            onMouseEnter={hideDog}
        />
    );
};

export default Dog; 